import { callAPI, HTTPMethod } from './API'
import {
    Projects,
    Project,
    ProjectListParams,
    ProjectRequest,
    ProjectPreview,
    ProjectStage,
    ProjectRedirect,
    ProjectRedirectUpdateRequest,
} from '../model/Project'

const getBaseApi = (tenantId?: string) =>
    `${tenantId ? `/tenants/${tenantId}` : ''}/projects`

const getSingleApi = (id: string, tenantId?: string) =>
    `${getBaseApi(tenantId)}/${id}`

const getParams = (params: ProjectListParams) => {
    return {
        pageSize: params?.pageSize?.toString() ?? '',
        offset: params?.offset?.toString() ?? '',
        search: params.search ?? '',
    }
}

export async function listProjects(
    params: ProjectListParams,
    tenantId?: string
): Promise<Projects> {
    return await callAPI(getBaseApi(tenantId), {
        method: HTTPMethod.GET,
        query: getParams(params),
    })
}

export async function createProject(
    request: ProjectRequest,
    tenantId?: string
): Promise<Project> {
    return await callAPI(getBaseApi(tenantId), {
        method: HTTPMethod.POST,
        body: request,
    })
}

export async function getProject(
    id: string,
    tenantId?: string
): Promise<Project> {
    return await callAPI(getSingleApi(id, tenantId), {
        method: HTTPMethod.GET,
    })
}

export async function updateProject(
    id: string,
    request: ProjectRequest,
    tenantId?: string
): Promise<Project> {
    return await callAPI(getSingleApi(id, tenantId), {
        method: HTTPMethod.PUT,
        body: request,
    })
}

export async function deleteProject(
    id: string,
    tenantId?: string
): Promise<any> {
    return await callAPI(getSingleApi(id, tenantId), {
        method: HTTPMethod.DELETE,
    })
}

export async function deployProject(
    id: string,
    tenantId?: string
): Promise<Project> {
    return await callAPI(`${getSingleApi(id, tenantId)}/deploy`, {
        method: HTTPMethod.PUT,
    })
}

export async function previewProject(
    id: string,
    stage: ProjectStage,
    tenantId?: string
): Promise<ProjectPreview> {
    return await callAPI(`${getSingleApi(id, tenantId)}/preview`, {
        method: HTTPMethod.GET,
        query: {
            stage: stage,
        },
    })
}

export async function getProjectRedirect(
    id: string,
    tenantId?: string
): Promise<ProjectRedirect> {
    return await callAPI(`${getSingleApi(id, tenantId)}/redirect`, {
        method: HTTPMethod.GET,
    })
}

export async function updateProjectRedirect(
    id: string,
    request: ProjectRedirectUpdateRequest,
    tenantId?: string
): Promise<ProjectRedirect> {
    return await callAPI(`${getSingleApi(id, tenantId)}/redirect`, {
        method: HTTPMethod.PUT,
        body: request,
    })
}
